var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDown = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "8px",
    viewBox: "0 0 12 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons/filled/content/add_24px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "16.59 8.59 12 13.17 7.41 8.59 6 10 12 16 18 10"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "v0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B5\\u30FC\\u30D3\\u30B9\\u8A73\\u7D30_\\u30DC\\u30C4",
    transform: "translate(-340.000000, -3030.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/filled/content/add_24px",
    transform: "translate(334.000000, 3022.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon/navigation/expand_more_24px",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)",
    fill: "#D95E2E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-Color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u21B3-\\uD83D\\uDC49Icon-Style",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow_down.57efeab908853bda1fc991a9f17ae659.svg";